import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import {changemakerLearningSec} from './ContentList1.module.css'

export default function ContentList1({data}) {
    const {contentList1BottomText, contentList1Subtitle, contentList1Title, contentList1Text, contentList1Image} = data
    return (
        <div className={`image-with-content-wrap p-line-25 changemaker-learning-sec ${changemakerLearningSec}`}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6 hide-mobile'>
                        <figure className='mb-0 change-learn-image'>
                            <GatsbyImage
                                image={getImage(contentList1Image?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                    <div className='col-md-6'>
                        <div className='img-with-content-rt-sec'>
                            <h2 className='heading-level-2 blue-color sm-text-center'>
                                {contentList1Title && parser(contentList1Title)}
                            </h2>
                            <p>{contentList1Subtitle && parser(contentList1Subtitle)}</p>
                            <div className='hubs-learn-image-bx hide-desk'>
                                <figure>
                                    <GatsbyImage
                                        image={getImage(contentList1Image?.localFile)}
                                        alt='image'
                                    />
                                </figure>
                            </div>
                            <div className='colored-content'>{contentList1Text && parser(contentList1Text)}</div>
                            <p>{contentList1BottomText && parser(contentList1BottomText)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
